import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import News from "../components/News/News";
import Searchbar from "../components/Searchbar/Searchbar";
import { fetchStaticData } from "../services/tweetService";
import { BASE_WEB_URL } from "../CONSTANTS";

export default function Constitution() {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [constitution, setConstitution] = useState("");
  useEffect(() => {
    fetchStaticData('constitutions').then(data => setConstitution(data));
  }, [dispatch]);

  return (
    <>
      <div className="notificationspage two-flex-col-container">
        <div className="col1 npc-1">
          {constitution && <><div className="notificationspage-header">
            <span className="notifications-text">{constitution.title}</span>
          </div>
          <div className="constitution-div">
          {constitution != '' && <embed src={ BASE_WEB_URL + constitution.asset_file}/>}
          </div></>}
        </div>
        <div className="col2 follow-sugg-news-container">
          <div className="follow-sugg-news-wrap">
            <Searchbar input={searchQuery}
              setInput={(value) => setSearchQuery(value)}/>
            <News />
            {/* <WhoToFollow /> */}
          </div>
        </div>
      </div>
    </>
  );
}
